import { createContext } from 'react';

import { SchedulingSectionContextType } from './SchedulingSectionContext.types';

export const SchedulingSectionContext = createContext<SchedulingSectionContextType>({
	config: {},
	updateConfig: () => {
		// eslint-disable-next-line no-console
	},
	error: undefined
});
